import React, { FunctionComponent } from 'react';
import HelpStyles from '../../Help.module.scss';

const Windows: FunctionComponent = () => {
  return (
    <div className={HelpStyles.sharedHelpStyles}>
      <div className={HelpStyles.steps}>
        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>1</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Go to <strong>Settings</strong> → <strong>Privacy & Security</strong> → <strong>Location</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>2</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Turn on <strong>Location services</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>3</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Turn on <strong>Allow apps to access your location</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>4</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Under <strong>Choose which apps can access your precise location</strong>, ensure your browser is enabled
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>5</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              For Microsoft Edge, ensure <strong>Microsoft Edge</strong> is enabled
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>6</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              For Chrome, ensure <strong>Google Chrome</strong> is enabled
            </p>
          </div>
        </div>
      </div>

      <div className={HelpStyles.tip}>
        <div className={HelpStyles.tipIcon}>💡</div>
        <div className={HelpStyles.tipContent}>
          <p className="fontFourteen poppins-regular text-gray">
            <strong>Tip:</strong> If you don't see your browser in the list, try opening it first, then check the settings again.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Windows;